import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1471.2,1261.68877 C1480.44,1328.88877 1476.12,1400.52877 1454.88,1477.32877 C1401.72,1667.40877 1278.24,1796.88877 1106.88,1842.12877 C1060.44,1854.36877 1012.32,1859.88877 963.84,1859.88877 C754.68,1859.88877 538.92,1755.84877 417,1634.76877 L417,1634.76877 L364.56,1578.72877 L540.24,1415.04877 L589.44,1467.96877 C688.2,1565.88877 892.92,1650.12877 1045.68,1610.04877 C1134.96,1586.40877 1193.16,1522.08877 1223.64,1413.12877 C1240.2,1353.12877 1240.8,1303.68877 1226.76,1261.68877 L1226.76,1261.68877 Z M1439.28,270.608772 L1275.48,445.928772 C1170.36,347.768772 956.28,269.768772 805.68,311.168772 C719.88,334.448772 664.08,393.248772 635.04,490.928772 C580.56,674.168772 701.76,742.928772 1012.8,836.408772 C1083.84,857.768772 1146.36,877.088772 1196.76,901.688772 L1920,901.688772 L1920,1141.68877 L-5.68434189e-14,1141.68877 L-5.68434189e-14,901.688772 L561.72,901.688772 C426.12,804.848772 335.04,658.088772 405,422.528772 C472.08,196.688772 625.68,111.368772 742.8,79.4487723 C990.6,12.7287723 1286.4,127.808772 1439.28,270.608772 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconStrikethroughSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconStrikethroughSolid, _Component);

  var _super = _createSuper(IconStrikethroughSolid);

  function IconStrikethroughSolid() {
    _classCallCheck(this, IconStrikethroughSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconStrikethroughSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconStrikethrough",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconStrikethroughSolid.displayName = "IconStrikethroughSolid";
  return IconStrikethroughSolid;
}(Component);

IconStrikethroughSolid.glyphName = 'strikethrough';
IconStrikethroughSolid.variant = 'Solid';
IconStrikethroughSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconStrikethroughSolid;
export { IconStrikethroughSolid };